import React, { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../Config/firebase";
import { AMBIENTE_PRODUCAO } from "../Config/branding";
import Navbar from "../Components/Navbar/navbar";
import useEstadoSalvamento from "../Utils/useEstadoSalvamento";
import { ROTAS_SISTEMA_SGQ } from "../routesSistema";
import { useHistory } from "react-router-dom";
import DescriptionIcon from "@mui/icons-material/Description";
import LinkIcon from "@mui/icons-material/Link";
import Tooltip from "@mui/material/Tooltip";
import {
  Autocomplete,
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Stack,
  List,
  ListItemButton,
  ListItemText,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  Collapse,
  CircularProgress,
  MenuItem,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FolderIcon from "@mui/icons-material/Folder";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import HistoryIcon from "@mui/icons-material/History";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import { usePermissoes } from "../../Hooks/usePermissoes";
import RelatorioFluxogramaSGQPrint from "./RelatorioFluxogramaSGQPrint";
import {
  getCategorias,
  getDocumentos,
  createCategoria,
  atualizarStatusCategoria,
  getDocumentosByCategoria,
  createDocumento,
  atualizarDocumento,
  getUltimaRevisao,
  createHistorico,
  getHistoricoByDocumento,
} from "./sgqService";
import {
  getStorage,
  ref,
  uploadBytes,
  getDownloadURL
} from "firebase/storage";

/* =========================
   UTIL
========================= */
const ORDEM_SIGLA = {
  MQ: 1,
  POP: 2,
  RQ: 3,
};

function slugify(text) {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

const storage = getStorage();

export default function AdminSGQ() {
  const { salvandoCadastro, executarSalvamento } = useEstadoSalvamento();
  const history = useHistory();
  const [categorias, setCategorias] = useState([]);
  const [docsPorCategoria, setDocsPorCategoria] = useState({});
  const [categoriaAberta, setCategoriaAberta] = useState(null);
  const [revisaoExibida, setRevisaoExibida] = useState("");
  const [documentoHistorico, setDocumentoHistorico] = useState(null);
  const [itensHistorico, setItensHistorico] = useState([]);
  const [carregandoHistorico, setCarregandoHistorico] = useState(false);
  const [erroHistorico, setErroHistorico] = useState("");

  /* ===== CATEGORIA ===== */
  const [dialogCatOpen, setDialogCatOpen] = useState(false);
  const [codigoCat, setCodigoCat] = useState("");
  const [tituloCat, setTituloCat] = useState("");

  /* ===== DOCUMENTO ===== */
  const [revisaoInicial, setRevisaoInicial] = useState(AMBIENTE_PRODUCAO ? "00" : "");

  const [dialogDocOpen, setDialogDocOpen] = useState(false);
  const [categoriaDialog, setCategoriaDialog] = useState(null);
  const [documentoSelecionado, setDocumentoSelecionado] = useState(null);

  const [codigoISO, setCodigoISO] = useState("");
  const [tituloDoc, setTituloDoc] = useState("");
  const [arquivo, setArquivo] = useState(null);
  const [perfisPermitidos, setPerfisPermitidos] = useState([]);

  const [codigoISOSigla, setCodigoISOSigla] = useState("");
  const [codigoISONumero, setCodigoISONumero] = useState("");
  const [modoEdicao, setModoEdicao] = useState("novo");
  // "novo" | "editarDados" | "novaRevisao"

  /* ===== CAMPOS LISTA MESTRA / LGPD ===== */
  const [tipo, setTipo] = useState("");
  const [dataEmissao, setDataEmissao] = useState("");
  const [responsavel, setResponsavel] = useState("");
  const [status, setStatus] = useState("");
  const [localArmazenamento, setLocalArmazenamento] = useState("");
  const [observacoes, setObservacoes] = useState("");

  const [dadosSensiveis, setDadosSensiveis] = useState("nao");
  const [tipoDado, setTipoDado] = useState("");
  const [justificativaTratamento, setJustificativaTratamento] = useState("");
  const [acessoRestrito, setAcessoRestrito] = useState("nao");
  const [medidaProtecao, setMedidaProtecao] = useState("");

  const [tipoDocumento, setTipoDocumento] = useState("pdf");
  const [rotaInterna, setRotaInterna] = useState("");
  const [modeloRota, setModeloRota] = useState("");

  const [erro, setErro] = useState("");
  const [salvando, setSalvando] = useState(false);

  const [pdfUrl, setPdfUrl] = useState(null);
  const [openPreview, setOpenPreview] = useState(false);

  const [claims, setClaims] = useState({});
  const [relatorioFluxograma, setRelatorioFluxograma] = useState(null);
  const [carregandoRelatorio, setCarregandoRelatorio] = useState(false);

  async function openNovaRevisao(doc, cat) {
    setCategoriaDialog(cat);
    setDocumentoSelecionado(doc);
    setModoEdicao("novaRevisao");

    setCodigoISOSigla(doc.codigoISOSigla);
    setCodigoISONumero(doc.codigoISONumero);
    setTituloDoc(doc.titulo);

    try {
      const ultima = await getUltimaRevisao(doc.id);

      const revisaoBase =
        ultima?.revisao ??
        doc.revisaoAtual ??
        "00";

      const proximaRevisao = String(
        parseInt(revisaoBase, 10) + 1
      ).padStart(2, "0");

      setRevisaoExibida(proximaRevisao);
    } catch (e) {
      console.error("Erro ao calcular próxima revisão", e);
      setRevisaoExibida("");
    }

    setTipoDocumento("pdf");
    setArquivo(null);
    setDialogDocOpen(true);
  }

  /* LOAD */
  useEffect(() => {
    carregarCategorias();
  }, []);

  useEffect(() => {
    if (dialogDocOpen && !documentoSelecionado) {
      setRevisaoInicial(AMBIENTE_PRODUCAO ? "00" : "");
    }
  }, [dialogDocOpen, documentoSelecionado]);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const token = await user.getIdTokenResult(true);
        setClaims(token.claims || {});
      } else {
        setClaims({});
      }
    });

    return () => unsub();
  }, []);

  const permissoes = usePermissoes(claims);

  async function carregarCategorias() {
    const cats = await getCategorias();
    setCategorias(cats);
  }

  async function toggleCategoria(cat) {
    setCategoriaAberta(cat.id);
    const docs = await getDocumentosByCategoria(cat.codigo, true);
    setDocsPorCategoria(prev => ({ ...prev, [cat.id]: docs }));
  }

  async function abrirRelatorioFluxograma() {
    try {
      setCarregandoRelatorio(true);
      setErro("");
      const documentos = await getDocumentos();
      const categoriasAtivas = categorias.filter(categoria => categoria.ativa !== false);
      const codigosCategoriasAtivas = new Set(categoriasAtivas.map(categoria => String(categoria.codigo)));
      setRelatorioFluxograma({
        categorias: categoriasAtivas,
        documentos: documentos.filter(documento => (
          documento.ativo !== false && codigosCategoriasAtivas.has(String(documento.categoriaCodigo))
        )),
      });
    } catch (e) {
      console.error("Erro ao gerar fluxograma do SGQ:", e);
      setErro("Não foi possível carregar os dados do fluxograma do SGQ.");
    } finally {
      setCarregandoRelatorio(false);
    }
  }

  /* ===== CATEGORIA ===== */
  async function salvarCategoria() {
    if (!codigoCat || !tituloCat) {
      setErro("Preencha código e título da categoria");
      return;
    }

    try {
      setSalvando(true);
      await createCategoria({ codigo: codigoCat, titulo: tituloCat });
      await carregarCategorias();
      setDialogCatOpen(false);
      setCodigoCat("");
      setTituloCat("");
      setErro("");
    } catch (e) {
      console.error(e);
      setErro("Erro ao salvar categoria");
    } finally {
      setSalvando(false);
    }
  }

  async function alternarStatusCategoria(categoria) {
    try {
      setErro("");
      setSalvando(true);
      await atualizarStatusCategoria(categoria.id, categoria.ativa === false);
      await carregarCategorias();
    } catch (e) {
      console.error(e);
      setErro("Erro ao alterar o status da categoria");
    } finally {
      setSalvando(false);
    }
  }

  async function abrirHistorico(documento) {
    setDocumentoHistorico(documento);
    setItensHistorico([]);
    setErroHistorico("");
    setCarregandoHistorico(true);

    try {
      setItensHistorico(await getHistoricoByDocumento(documento.id));
    } catch (e) {
      console.error(e);
      setErroHistorico("Erro ao carregar histórico do documento.");
    } finally {
      setCarregandoHistorico(false);
    }
  }

  /* ===== LER PDF ABRIR PREVIEW ===== */
  async function abrirDocumento(doc) {
    if (doc.origemDocumento === "rota" && doc.rotaInterna) {
      history.push(doc.rotaInterna);
      return;
    }

    if (doc.storagePath) {
      const url = await getDownloadURL(ref(storage, doc.storagePath));
      setPdfUrl(url);
      setOpenPreview(true);
      return;
    }

    alert("Documento sem conteúdo vinculado");
  }

  /* ===== DOCUMENTO ===== */
  function openNovoDocumento(cat) {
    setCategoriaDialog(cat);
    setDocumentoSelecionado(null);
    setModoEdicao("novo");

    setCodigoISOSigla("");
    setCodigoISONumero("");
    setTituloDoc("");
    setArquivo(null);
    setTipoDocumento("pdf");
    setRotaInterna("");
    setModeloRota("");
    setPerfisPermitidos([]);
    setRevisaoInicial(AMBIENTE_PRODUCAO ? "00" : "");
    setTipo("Digital");
    setDataEmissao("");
    setResponsavel("Silvio");
    setStatus("ativo");
    setLocalArmazenamento("Aplicação WEB");
    setObservacoes("");

    setDadosSensiveis("nao");
    setTipoDado("Documento SGQ");
    setJustificativaTratamento("");
    setAcessoRestrito("nao");
    setMedidaProtecao("Somente usuário logado");

    setErro("");
    setPdfUrl(null);
    setDialogDocOpen(true);
  }

  function openEditarDados(doc, cat) {
    setCategoriaDialog(cat);
    setDocumentoSelecionado(doc);
    setModoEdicao("editarDados");

    setCodigoISOSigla(doc.codigoISOSigla);
    setCodigoISONumero(doc.codigoISONumero);
    setTituloDoc(doc.titulo);

    setRevisaoExibida(doc.revisaoAtual);

    setTipo(doc.tipo || "");
    setDataEmissao(doc.dataEmissao || "");
    setResponsavel(doc.responsavel || "");
    setStatus(doc.status || "");
    setLocalArmazenamento(doc.localArmazenamento || "");
    setObservacoes(doc.observacoes || "");

    setDadosSensiveis(doc.dadosSensiveis || "nao");
    setTipoDado(doc.tipoDado || "");
    setJustificativaTratamento(doc.justificativaTratamento || "");
    setAcessoRestrito(doc.acessoRestrito || "nao");
    setMedidaProtecao(doc.medidaProtecao || "");

    setTipoDocumento(doc.origemDocumento || "pdf");
    setRotaInterna(doc.rotaInterna || "");
    setModeloRota(doc.rotaInterna || "");
    setArquivo(null);

    setErro("");
    setDialogDocOpen(true);
  }

  function fecharDialogDocumento() {
    setDialogDocOpen(false);
    setArquivo(null);
    setErro("");
    setSalvando(false);
    setRevisaoInicial(AMBIENTE_PRODUCAO ? "00" : "");
    setRevisaoExibida("");
    setModoEdicao("novo");
    setRotaInterna("");
    setModeloRota("");
  }

  async function salvarDocumento() {

    /* =========================================================
       NOVA REVISÃO
       ========================================================= */
    if (modoEdicao === "novaRevisao") {
      if (!arquivo) {
        setErro("Para salvar uma nova revisão é obrigatório selecionar um arquivo PDF.");
        return;
      }

      const nomeAnterior = documentoSelecionado?.storagePath
        ?.split("/")
        .pop();

      if (arquivo.name === nomeAnterior) {
        setErro("O arquivo da nova revisão deve ter um nome diferente da revisão atual.");
        return;
      }
    }

    /* =========================================================
       EDITAR DADOS
       Agora permite alterar PDF <-> ROTA.
       ========================================================= */
    if (modoEdicao === "editarDados") {

      if (dadosSensiveis === "sim" && !justificativaTratamento) {
        setErro("Informe a justificativa do tratamento para dados sensíveis");
        return;
      }

      if (tipoDocumento === "rota" && !rotaInterna) {
        setErro("Informe a rota do sistema");
        return;
      }

      if (
        tipoDocumento === "rota" &&
        rotaInterna.split("/").some(parte => parte.startsWith(":"))
      ) {
        setErro("Preencha os identificadores da rota selecionada.");
        return;
      }

      // ROTA -> PDF: exige novo PDF
      if (
        tipoDocumento === "pdf" &&
        documentoSelecionado?.origemDocumento === "rota" &&
        !arquivo
      ) {
        setErro("Ao alterar de ROTA para PDF, selecione o arquivo PDF.");
        return;
      }

      try {
        setSalvando(true);

        let novoStoragePath = "";

        // PDF -> PDF: mantém o PDF atual
        if (
          tipoDocumento === "pdf" &&
          documentoSelecionado?.origemDocumento === "pdf" &&
          !arquivo
        ) {
          novoStoragePath = documentoSelecionado.storagePath || "";
        }

        // ROTA -> PDF: cria/atualiza o PDF atual
        if (tipoDocumento === "pdf" && arquivo) {
          const basePath = `sgq/${slugify(
            categoriaDialog.titulo
          )}/${slugify(
            documentoSelecionado.codigoISO
          )}/${slugify(
            documentoSelecionado.titulo
          )}`;

          novoStoragePath = `${basePath}/atual.pdf`;

          await uploadBytes(
            ref(storage, novoStoragePath),
            arquivo
          );
        }

        // PDF -> ROTA ou ROTA -> ROTA:
        // não mantém vínculo com PDF.
        if (tipoDocumento === "rota") {
          novoStoragePath = "";
        }

        await atualizarDocumento(documentoSelecionado.id, {
          tipo,
          dataEmissao,
          responsavel,
          status,
          localArmazenamento,
          observacoes,

          dadosSensiveis,
          tipoDado,
          justificativaTratamento,
          acessoRestrito,
          medidaProtecao,

          // 🔄 ALTERAÇÃO DO TIPO DE DOCUMENTO
          origemDocumento: tipoDocumento,

          // 🔗 ROTA
          rotaInterna:
            tipoDocumento === "rota"
              ? rotaInterna
              : "",

          // 📄 PDF
          storagePath: novoStoragePath,
        });

        await createHistorico({
          documentoId: documentoSelecionado.id,
          codigoISO: documentoSelecionado.codigoISO,
          titulo: documentoSelecionado.titulo,
          storagePath:
            tipoDocumento === "pdf"
              ? novoStoragePath
              : "",
          revisao: documentoSelecionado.revisaoAtual || "00",
          acao: "edicaoDados",
        });

        const docs = await getDocumentosByCategoria(
          categoriaDialog.codigo,
          true
        );

        setDocsPorCategoria(prev => ({
          ...prev,
          [categoriaDialog.id]: docs,
        }));

        fecharDialogDocumento();
        return;

      } catch (e) {
        console.error(e);
        setErro("Erro ao atualizar documento");
        setSalvando(false);
        return;
      }
    }

    /* =========================================================
       VALIDAÇÕES PARA NOVO DOCUMENTO / NOVA REVISÃO
       ========================================================= */

    if (dadosSensiveis === "sim" && !justificativaTratamento) {
      setErro("Informe a justificativa do tratamento para dados sensíveis");
      setSalvando(false);
      return;
    }

    if (tipoDocumento === "rota" && !rotaInterna) {
      setErro("Informe a rota do sistema");
      setSalvando(false);
      return;
    }

    if (
      tipoDocumento === "rota" &&
      rotaInterna.split("/").some(parte => parte.startsWith(":"))
    ) {
      setErro("Preencha os identificadores da rota selecionada.");
      setSalvando(false);
      return;
    }

    if (!codigoISOSigla || !codigoISONumero) {
      setErro("Informe a sigla e o número do código ISO");
      setSalvando(false);
      return;
    }

    try {
      setSalvando(true);

      const codigoISOCompleto = `${codigoISOSigla} ${codigoISONumero}`;

      const codigoISOOrder = codigoISONumero
        .split(".")
        .map(n => n.padStart(3, "0"))
        .join(".");

      const basePath = `sgq/${slugify(
        categoriaDialog.titulo
      )}/${slugify(codigoISOCompleto)}/${slugify(tituloDoc)}`;

      /* =========================
         NOVO DOCUMENTO
      ========================= */
      if (!documentoSelecionado) {

        if (tipoDocumento === "pdf" && !arquivo) {
          setErro("Selecione um arquivo PDF.");
          setSalvando(false);
          return;
        }

        if (!revisaoInicial) {
          setErro("Informe a revisão inicial do documento");
          setSalvando(false);
          return;
        }

        const revInicial = String(
          parseInt(revisaoInicial, 10)
        ).padStart(2, "0");

        let atual = "";
        let rev = "";

        if (tipoDocumento === "pdf") {
          atual = `${basePath}/atual.pdf`;
          rev = `${basePath}/rev-${revInicial}.pdf`;
        }

        if (tipoDocumento === "pdf") {
          await uploadBytes(ref(storage, atual), arquivo);
          await uploadBytes(ref(storage, rev), arquivo);
        }

        const docRef = await createDocumento({
          codigoISO: codigoISOCompleto,
          codigoISOSigla,
          codigoISONumero,
          codigoISOOrder,

          titulo: tituloDoc,
          categoriaCodigo: categoriaDialog.codigo,
          categoriaTitulo: categoriaDialog.titulo,

          origemDocumento: tipoDocumento,
          rotaInterna:
            tipoDocumento === "rota"
              ? rotaInterna
              : "",
          storagePath:
            tipoDocumento === "pdf"
              ? atual
              : "",
          revisaoAtual: revInicial,

          tipo,
          dataEmissao,
          responsavel,
          status,
          localArmazenamento,
          observacoes,
          dadosSensiveis,
          tipoDado,
          justificativaTratamento,
          acessoRestrito,
          medidaProtecao,
        });

        await createHistorico({
          documentoId: docRef.id,
          codigoISO: codigoISOCompleto,
          titulo: tituloDoc,
          storagePath:
            tipoDocumento === "pdf"
              ? rev
              : "",
          revisao: revInicial,
        });

      /* =========================
         ATUALIZA DOCUMENTO
      ========================= */
      } else {

        const ultima = await getUltimaRevisao(
          documentoSelecionado.id
        );

        const novaRev = String(
          parseInt(ultima?.revisao || "00", 10) + 1
        ).padStart(2, "0");

        const atual = `${basePath}/atual.pdf`;
        const rev = `${basePath}/rev-${novaRev}.pdf`;

        if (tipoDocumento === "pdf") {
          await uploadBytes(ref(storage, atual), arquivo);
          await uploadBytes(ref(storage, rev), arquivo);
        }

        await atualizarDocumento(
          documentoSelecionado.id,
          {
            storagePath:
              tipoDocumento === "pdf"
                ? atual
                : "",

            rotaInterna:
              tipoDocumento === "rota"
                ? rotaInterna
                : "",

            origemDocumento: tipoDocumento,

            revisaoAtual: novaRev,

            tipo,
            dataEmissao,
            responsavel,
            status,
            localArmazenamento,
            observacoes,
            dadosSensiveis,
            tipoDado,
            justificativaTratamento,
            acessoRestrito,
            medidaProtecao,
          }
        );

        await createHistorico({
          documentoId: documentoSelecionado.id,
          codigoISO: codigoISOCompleto,
          titulo: tituloDoc,
          storagePath:
            tipoDocumento === "pdf"
              ? rev
              : "",
          revisao: novaRev,
        });
      }

      const docs = await getDocumentosByCategoria(
        categoriaDialog.codigo,
        true
      );

      setDocsPorCategoria(prev => ({
        ...prev,
        [categoriaDialog.id]: docs,
      }));

      fecharDialogDocumento();

    } catch (e) {
      console.error(e);
      setErro("Erro ao salvar documento");
    } finally {
      setSalvando(false);
    }
  }

  if (relatorioFluxograma) {
    return (
      <RelatorioFluxogramaSGQPrint
        categorias={relatorioFluxograma.categorias}
        documentos={relatorioFluxograma.documentos}
        onVoltar={() => setRelatorioFluxograma(null)}
      />
    );
  }

  return (
    <Box>
      <Navbar />

      <Box sx={{ p: 3 }}>
        <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" alignItems={{ sm: "center" }} spacing={2} mb={3}>
          <Typography variant="h4">Admin SGQ</Typography>
          <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
            <Button
              variant="outlined"
              startIcon={<AccountTreeIcon />}
              onClick={abrirRelatorioFluxograma}
              disabled={carregandoRelatorio || categorias.length === 0}
            >
              {carregandoRelatorio ? "Carregando..." : "Relatório do fluxograma"}
            </Button>
            {permissoes.podeEditarSGQ && (
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => setDialogCatOpen(true)}
              >
                Nova Categoria
              </Button>
            )}
          </Stack>
        </Stack>

        {categorias.map(cat => (
          <Card
            key={cat.id}
            sx={{
              mb: 2,
              opacity: cat.ativa === false ? 0.7 : 1
            }}
          >
            <CardContent>
              <Stack direction="row" alignItems="center">
                <ListItemButton
                  onClick={() => toggleCategoria(cat)}
                >
                  <FolderIcon sx={{ mr: 1 }} />

                  <ListItemText
                    primary={`${cat.codigo}. ${cat.titulo}`}
                    secondary={
                      cat.ativa === false
                        ? "Categoria desativada"
                        : null
                    }
                  />
                </ListItemButton>

                {permissoes.podeEditarSGQ && (
                  <Stack
                    direction="row"
                    spacing={1}
                    alignItems="center"
                  >
                    {cat.ativa !== false && (
                      <IconButton
                        onClick={() => openNovoDocumento(cat)}
                      >
                        <AddIcon />
                      </IconButton>
                    )}

                    <Button
                      size="small"
                      variant="outlined"
                      color={
                        cat.ativa === false
                          ? "success"
                          : "error"
                      }
                      onClick={() =>
                        alternarStatusCategoria(cat)
                      }
                      disabled={salvando}
                    >
                      {cat.ativa === false
                        ? "Ativar"
                        : "Desativar"}
                    </Button>
                  </Stack>
                )}
              </Stack>

              <Collapse in={categoriaAberta === cat.id}>
                <List sx={{ pl: 4 }}>
                  {(docsPorCategoria[cat.id] || [])
                    .slice()
                    .sort((a, b) => {
                      const ordemA =
                        ORDEM_SIGLA[a.codigoISOSigla] ?? 99;
                      const ordemB =
                        ORDEM_SIGLA[b.codigoISOSigla] ?? 99;

                      if (ordemA !== ordemB) {
                        return ordemA - ordemB;
                      }

                      if (
                        a.codigoISOOrder <
                        b.codigoISOOrder
                      )
                        return -1;

                      if (
                        a.codigoISOOrder >
                        b.codigoISOOrder
                      )
                        return 1;

                      return 0;
                    })
                    .map(doc => (
                      <Stack
                        key={doc.id}
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <ListItemButton
                          disabled={
                            doc.origemDocumento === "pdf" &&
                            !doc.storagePath
                          }
                          onClick={() =>
                            abrirDocumento(doc)
                          }
                          sx={{
                            flex: 1,
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}
                        >
                          <Tooltip
                            title={
                              doc.origemDocumento ===
                              "rota"
                                ? "Rota do sistema"
                                : "Documento PDF"
                            }
                          >
                            {doc.origemDocumento ===
                            "rota" ? (
                              <LinkIcon
                                fontSize="small"
                                color="action"
                              />
                            ) : (
                              <DescriptionIcon
                                fontSize="small"
                                color="action"
                              />
                            )}
                          </Tooltip>

                          <ListItemText
                            primary={
                              <Typography
                                sx={{
                                  color: "primary.main",
                                  cursor: "pointer",
                                  fontWeight: 500,
                                }}
                              >
                                {`${doc.codigoISO} — ${doc.titulo}${
                                  doc.origemDocumento === "pdf"
                                    ? ` REV.${doc.revisaoAtual}`
                                    : ""
                                }`}

                                <Typography
                                  component="span"
                                  variant="body2"
                                  color="text.secondary"
                                  sx={{ ml: 1 }}
                                >
                                  {doc.envioRevisaoAtual?.createdAt?.toDate
                                    ? `— Adicionado em ${doc.envioRevisaoAtual.createdAt.toDate().toLocaleDateString("pt-BR")}`
                                    : "— Data de adição não registrada"}

                                  {` — Por: ${
                                    doc.envioRevisaoAtual
                                      ?.userName ||
                                    doc.envioRevisaoAtual
                                      ?.userEmail ||
                                    doc.envioRevisaoAtual
                                      ?.userId ||
                                    "Usuário não identificado"
                                  }`}
                                </Typography>
                              </Typography>
                            }
                          />
                        </ListItemButton>

                        <Button
                          size="small"
                          startIcon={<HistoryIcon />}
                          onClick={() =>
                            abrirHistorico(doc)
                          }
                        >
                          Histórico
                        </Button>

                        {permissoes.podeEditarSGQ && (
                          <Stack
                            direction="row"
                            spacing={1}
                          >
                            <Tooltip title="Editar dados (sem nova revisão)">
                              <IconButton
                                onClick={() =>
                                  openEditarDados(
                                    doc,
                                    cat
                                  )
                                }
                              >
                                ✏️
                              </IconButton>
                            </Tooltip>

                            {doc.origemDocumento ===
                              "pdf" && (
                              <Tooltip title="Subir nova revisão do PDF">
                                <IconButton
                                  onClick={() =>
                                    openNovaRevisao(
                                      doc,
                                      cat
                                    )
                                  }
                                >
                                  <AutorenewIcon />
                                </IconButton>
                              </Tooltip>
                            )}
                          </Stack>
                        )}
                      </Stack>
                    ))}
                </List>
              </Collapse>
            </CardContent>
          </Card>
        ))}
      </Box>

      {/* DIALOG HISTÓRICO */}
      <Dialog
        open={!!documentoHistorico}
        onClose={() =>
          !carregandoHistorico &&
          setDocumentoHistorico(null)
        }
        fullWidth
      >
        <DialogTitle>
          Histórico — {documentoHistorico?.titulo}
        </DialogTitle>

        <DialogContent>
          {carregandoHistorico ? (
            <CircularProgress size={24} />
          ) : erroHistorico ? (
            <Alert severity="error">
              {erroHistorico}
            </Alert>
          ) : itensHistorico.length === 0 ? (
            <Typography color="text.secondary">
              Nenhuma versão registrada
            </Typography>
          ) : (
            <List>
              {itensHistorico.map(item => (
                <ListItemButton
                  key={item.id}
                  onClick={async () => {
                    if (!item.storagePath) return;

                    try {
                      await abrirDocumento({
                        storagePath:
                          item.storagePath
                      });
                    } catch (e) {
                      console.error(e);
                      setErroHistorico(
                        "Erro ao abrir PDF da revisão."
                      );
                    }
                  }}
                >
                  <ListItemText
                    primary={
                      item.acao === "edicaoDados"
                        ? `Edição de dados — Revisão ${item.revisao}`
                        : `Revisão ${item.revisao}`
                    }
                    secondary={
                      <>
                        <Typography
                          component="span"
                          variant="body2"
                        >
                          Responsável:{" "}
                          {item.userName ||
                            item.userEmail ||
                            "Usuário não identificado"}

                          {item.userEmail &&
                          item.userEmail !==
                            item.userName
                            ? ` (${item.userEmail})`
                            : ""}
                        </Typography>

                        <br />

                        <Typography
                          component="span"
                          variant="caption"
                          color="text.secondary"
                        >
                          {item.createdAt?.toDate?.()
                            ?.toLocaleString(
                              "pt-BR"
                            ) || ""}
                        </Typography>
                      </>
                    }
                  />
                </ListItemButton>
              ))}
            </List>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            disabled={carregandoHistorico}
            onClick={() =>
              setDocumentoHistorico(null)
            }
          >
            Fechar
          </Button>
        </DialogActions>
      </Dialog>

      {/* DIALOG CATEGORIA */}
      <Dialog
        open={dialogCatOpen}
        onClose={() =>
          !salvandoCadastro &&
          setDialogCatOpen(false)
        }
      >
        <DialogTitle>Nova Categoria</DialogTitle>

        <DialogContent>
          {erro && (
            <Alert severity="error">
              {erro}
            </Alert>
          )}

          <TextField
            label="Código"
            fullWidth
            margin="dense"
            value={codigoCat}
            onChange={e =>
              setCodigoCat(e.target.value)
            }
          />

          <TextField
            label="Título"
            fullWidth
            margin="dense"
            value={tituloCat}
            onChange={e =>
              setTituloCat(e.target.value)
            }
          />
        </DialogContent>

        <DialogActions>
          <Button
            onClick={() =>
              setDialogCatOpen(false)
            }
            disabled={salvandoCadastro}
          >
            Cancelar
          </Button>

          <Button
            variant="contained"
            onClick={() =>
              executarSalvamento(salvarCategoria)
            }
            disabled={salvandoCadastro}
          >
            {salvandoCadastro
              ? "Salvando..."
              : "Salvar"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* DIALOG DOCUMENTO */}
      <Dialog
        open={dialogDocOpen}
        onClose={fecharDialogDocumento}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle>
          {documentoSelecionado
            ? modoEdicao === "novaRevisao"
              ? "Nova Revisão"
              : "Atualizar Documento"
            : "Novo Documento"}
        </DialogTitle>

        <DialogContent dividers>
          {erro && (
            <Alert severity="error">
              {erro}
            </Alert>
          )}

          {/* IDENTIFICAÇÃO */}
          <TextField
            label="Sigla (MQ, POP, RQ)"
            fullWidth
            margin="dense"
            value={codigoISOSigla}
            onChange={e =>
              setCodigoISOSigla(
                e.target.value
                  .toUpperCase()
                  .replace(/[^A-Z]/g, "")
              )
            }
            disabled={!!documentoSelecionado}
          />

          <TextField
            label="Número ISO (ex: 1.2, 10.3)"
            fullWidth
            margin="dense"
            value={codigoISONumero}
            onChange={e =>
              setCodigoISONumero(
                e.target.value.replace(
                  /[^0-9.]/g,
                  ""
                )
              )
            }
            disabled={!!documentoSelecionado}
          />

          <TextField
            label="Título"
            fullWidth
            margin="dense"
            value={tituloDoc}
            onChange={e =>
              setTituloDoc(e.target.value)
            }
            disabled={!!documentoSelecionado}
          />

          {/* REVISÃO */}
          {documentoSelecionado && tipoDocumento === "pdf" && (
            <TextField
              label={
                modoEdicao === "novaRevisao"
                  ? "Nova Revisão"
                  : "Revisão Atual"
              }
              fullWidth
              margin="dense"
              value={revisaoExibida}
              disabled
            />
          )}

          {!documentoSelecionado &&
            tipoDocumento === "pdf" && (
              <TextField
                label="Revisão Inicial"
                fullWidth
                margin="dense"
                value={revisaoInicial}
                onChange={e =>
                  setRevisaoInicial(
                    e.target.value.replace(
                      /\D/g,
                      ""
                    )
                  )
                }
                inputProps={{ maxLength: 2 }}
              />
            )}

          {/* LISTA MESTRA */}
          <TextField
            label="Tipo"
            fullWidth
            margin="dense"
            value={tipo}
            onChange={e =>
              setTipo(e.target.value)
            }
          />

          <TextField
            type="date"
            label="Data de Emissão"
            fullWidth
            margin="dense"
            InputLabelProps={{ shrink: true }}
            value={dataEmissao}
            onChange={e =>
              setDataEmissao(e.target.value)
            }
          />

          <TextField
            label="Responsável"
            fullWidth
            margin="dense"
            value={responsavel}
            onChange={e =>
              setResponsavel(e.target.value)
            }
          />

          <TextField
            label="Status"
            fullWidth
            margin="dense"
            value={status}
            onChange={e =>
              setStatus(e.target.value)
            }
          />

          <TextField
            label="Local de Armazenamento"
            fullWidth
            margin="dense"
            value={localArmazenamento}
            onChange={e =>
              setLocalArmazenamento(
                e.target.value
              )
            }
          />

          <TextField
            label="Observações"
            fullWidth
            margin="dense"
            multiline
            rows={2}
            value={observacoes}
            onChange={e =>
              setObservacoes(e.target.value)
            }
          />

          {/* LGPD */}
          <TextField
            select
            label="Dados Pessoais Sensíveis?"
            fullWidth
            margin="dense"
            value={dadosSensiveis}
            onChange={e =>
              setDadosSensiveis(e.target.value)
            }
          >
            <MenuItem value="nao">
              Não
            </MenuItem>
            <MenuItem value="sim">
              Sim
            </MenuItem>
          </TextField>

          <TextField
            label="Tipo de Dado"
            fullWidth
            margin="dense"
            value={tipoDado}
            onChange={e =>
              setTipoDado(e.target.value)
            }
          />

          <TextField
            label="Justificativa do Tratamento"
            fullWidth
            margin="dense"
            value={justificativaTratamento}
            onChange={e =>
              setJustificativaTratamento(
                e.target.value
              )
            }
          />

          <TextField
            select
            label="Acesso Restrito?"
            fullWidth
            margin="dense"
            value={acessoRestrito}
            onChange={e =>
              setAcessoRestrito(e.target.value)
            }
          >
            <MenuItem value="nao">
              Não
            </MenuItem>
            <MenuItem value="sim">
              Sim
            </MenuItem>
          </TextField>

          <TextField
            label="Medida de Proteção"
            fullWidth
            margin="dense"
            value={medidaProtecao}
            onChange={e =>
              setMedidaProtecao(
                e.target.value
              )
            }
          />

          {/* TIPO DE DOCUMENTO */}
          <TextField
            select
            label="Tipo de Documento"
            fullWidth
            margin="dense"
            value={tipoDocumento}
            onChange={e => {
              const novoTipo = e.target.value;

              setTipoDocumento(novoTipo);

              if (novoTipo === "rota") {
                setArquivo(null);
              }

              if (novoTipo === "pdf") {
                setRotaInterna("");
                setModeloRota("");
              }
            }}
          >
            <MenuItem value="pdf">
              Arquivo PDF
            </MenuItem>

            <MenuItem value="rota">
              Rota do Sistema
            </MenuItem>
          </TextField>

          {tipoDocumento === "rota" && (
            <>
              <Autocomplete
                options={ROTAS_SISTEMA_SGQ.filter(rota => {
                  const registrarOcorrencias =
                    rota.path === "/kpi/evento/:kpiId";

                  return (
                    (!rota.path.includes(":") || registrarOcorrencias) &&
                    !rota.path.endsWith("/novo") &&
                    rota.path !== "/app/NovoCadastroMateriais" &&
                    (!rota.path.startsWith("/kpi/evento/") ||
                      registrarOcorrencias)
                  );
                })}
                value={
                  ROTAS_SISTEMA_SGQ.find(
                    rota =>
                      rota.path ===
                      (modeloRota ||
                        rotaInterna)
                  ) || null
                }
                getOptionLabel={rota =>
                  rota.label
                }
                isOptionEqualToValue={(
                  opcao,
                  valor
                ) =>
                  opcao.path === valor.path
                }
                onChange={(event, rota) => {
                  setModeloRota(
                    rota?.path || ""
                  );
                  setRotaInterna(
                    rota?.path || ""
                  );
                }}
                noOptionsText="Nenhuma rota encontrada"
                fullWidth
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Pesquisar rota"
                    placeholder="Digite o nome do item"
                    margin="dense"
                  />
                )}
              />

              {modeloRota
                .split("/")
                .map(
                  (parte, indice) =>
                    parte.startsWith(":") && (
                      <TextField
                        key={parte}
                        label={`Identificador do registro (${parte.slice(
                          1
                        )})`}
                        value={
                          rotaInterna.split(
                            "/"
                          )[indice] === parte
                            ? ""
                            : decodeURIComponent(
                                rotaInterna.split(
                                  "/"
                                )[indice] || ""
                              )
                        }
                        onChange={event => {
                          const partes =
                            rotaInterna.split(
                              "/"
                            );

                          partes[indice] =
                            event.target.value.trim()
                              ? encodeURIComponent(
                                  event.target.value.trim()
                                )
                              : parte;

                          setRotaInterna(
                            partes.join("/")
                          );
                        }}
                        helperText="Informe o ID do registro que este documento deve abrir."
                        fullWidth
                        margin="dense"
                        required
                      />
                    )
                )}
            </>
          )}
        </DialogContent>

        {/* RODAPÉ */}
        <DialogActions
          sx={{
            display: "flex",
            justifyContent:
              "space-between",
            alignItems: "center",
            px: 3,
            py: 2,
          }}
        >
          {/* ESQUERDA — PDF */}
          <Box>
            {tipoDocumento === "pdf" && (
              <Button
                component="label"
                variant="outlined"
              >
                Selecionar PDF

                <input
                  hidden
                  type="file"
                  accept="application/pdf"
                  onChange={e =>
                    setArquivo(
                      e.target.files[0]
                    )
                  }
                />
              </Button>
            )}

            {arquivo && (
              <Typography
                variant="caption"
                display="block"
                sx={{ mt: 0.5 }}
              >
                Arquivo:{" "}
                <strong>
                  {arquivo.name}
                </strong>
              </Typography>
            )}
          </Box>

          {/* DIREITA — AÇÕES */}
          <Stack
            direction="row"
            spacing={1}
          >
            <Button
              onClick={
                fecharDialogDocumento
              }
            >
              Cancelar
            </Button>

            <Button
              variant="contained"
              onClick={salvarDocumento}
              disabled={salvando}
            >
              {salvando ? (
                <CircularProgress
                  size={18}
                />
              ) : (
                "Salvar"
              )}
            </Button>
          </Stack>
        </DialogActions>
      </Dialog>

      {/* PREVIEW PDF */}
      <Dialog
        open={openPreview}
        onClose={() =>
          setOpenPreview(false)
        }
        fullWidth
        maxWidth="lg"
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent:
              "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          Visualização do Documento

          <Button
            onClick={() =>
              setOpenPreview(false)
            }
            variant="outlined"
            size="small"
          >
            Fechar
          </Button>
        </DialogTitle>

        <DialogContent>
          {pdfUrl && (
            <iframe
              src={pdfUrl}
              title="preview"
              style={{
                width: "100%",
                height: "80vh",
                border: "none",
              }}
            />
          )}
        </DialogContent>
      </Dialog>
    </Box>
  );
}
